import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { Link, Text } from '@chakra-ui/react';
import auth from '@udacity/ureact-hoth';
import PropTypes from 'prop-types';

import { useGetMentorQuery } from 'app/mentor/queries/enhanced';

import CONFIG from 'configLoader';
import PayoneerActive from './payoneer-active';
import PayoneerExplanation from './payoneer-explanation';
import PayoneerPending from './payoneer-pending';
import { PayoneerStageOne } from './payoneer-stage-one';
import styles from './payment-settings.module.scss';

export class PaymentSettings extends Component {
  static propTypes = {
    payoneer: PropTypes.objectOf(PropTypes.string).isRequired,
  };

  render() {
    const {
      payoneer: { status },
      t,
    } = this.props;

    const { payoneerLoginUrl, payoneerRegistrationUrl } = CONFIG;

    let payoneerActions;

    switch (status) {
      // no payoneer account linked
      case null:
        payoneerActions = <PayoneerStageOne logIn={payoneerLoginUrl} signUp={payoneerRegistrationUrl} />;
        break;
      // payoneer account pending
      case 'INACTIVE':
        payoneerActions = <PayoneerPending logIn={payoneerLoginUrl} />;
        break;
      // successfully linked payoneer account
      case 'ACTIVE':
        payoneerActions = <PayoneerActive logIn={payoneerLoginUrl} />;
        break;
      // application page
      default:
        payoneerActions = <PayoneerExplanation />;
    }

    return (
      <section className={styles['payment-information']}>
        <Text size="label" as="h5" mb={2}>
          {t('mentorProfile.payoneer.paymentSettings')}
        </Text>
        <Text color="gray.700" mb={2}>
          <Trans
            i18nKey="mentorProfile.payoneer.udacityHasPartnered"
            components={{
              read_more_link: (
                <Link
                  href="https://payouts.payoneer.com/Partners/Default/faq.aspx?pid=100094130"
                  isExternal
                  fontSize="sm"
                />
              ),
            }}
          />
        </Text>
        {payoneerActions}
      </section>
    );
  }
}

const TranslatedPaymentSettings = withTranslation()(PaymentSettings);

const PaymentSettingsContainer = (props) => {
  const uid = auth.getCurrentUserId() || '';
  const { data } = useGetMentorQuery({ uid }, { skip: !uid });

  return <TranslatedPaymentSettings {...props} payoneer={{ status: data?.mentor?.payoneer_status }} />;
};

export default PaymentSettingsContainer;
